import enabled from './enabled'
import handleToggle from './handleToggle'

export default (form, baseName, isItem, items, on, toggle) => () => {
  handleToggle(items, on, toggle)

  if (enabled(form, baseName)) return

  const {
    setFieldValue,
  } = form

  setFieldValue(`${baseName}.enabled`, true)

  if (!isItem) return

  const parentBaseName = baseName.split('.')[0]
  setFieldValue(`${parentBaseName}.enabled`, true)
}
